import { SVGProps, Ref, forwardRef } from "react";

const WarningIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 24 21"
    fill="none"
    width="1em"
    height="1em"
    ref={ref}
    aria-label="Warning Icon"
    {...props}
  >
    <title id="Warning Icon">Warning Icon</title>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12 8v4m0 4h.01M10.615 2.892 2.39 17.098c-.456.788-.684 1.182-.65 1.506a1 1 0 0 0 .406.705c.263.191.718.191 1.629.191h16.45c.91 0 1.365 0 1.628-.191a1 1 0 0 0 .407-.705c.034-.324-.195-.718-.65-1.506L13.383 2.892c-.454-.785-.681-1.178-.978-1.31a1 1 0 0 0-.813 0c-.296.132-.523.525-.978 1.31Z"
    />
  </svg>
);

const ForwardRef = forwardRef(WarningIcon);
export default ForwardRef;
